import { parseDocumentFromString } from 'anodum';
import { getAttributes } from './rules';

const extractAllowedAttributes = (html, allowedAttributes = getAttributes()) => {
  const doc = parseDocumentFromString(html);
  const attributesSelector = allowedAttributes.map((attr) => `[${attr}]`).join(', ');
  const attributes = [];

  doc.querySelectorAll(attributesSelector).forEach((node) => {
    Array.from(node.attributes).forEach((attr) => {
      const [maybePrefix, base] = attr.name.split(':');
      const isResponsive = base !== undefined;
      const attrName = isResponsive ? base : maybePrefix;

      if (allowedAttributes.includes(attrName)) {
        const attrString = `${attr.name}='${attr.value}'`;
        if (!attributes.includes(attrString)) {
          attributes.push(attrString);
        }
      }
    });
  });

  return attributes;
};

export default extractAllowedAttributes;
